require('./dirPagination');
module.exports = 'angularUtils.directives.dirPagination';



//////////////////
// WEBPACK FOOTER
// ./~/angular-utils-pagination/index.js
// module id = 69
// module chunks = 0